import { render } from "./Damage.vue?vue&type=template&id=b0bce9c2&scoped=true"
import script from "./Damage.vue?vue&type=script&lang=js"
export * from "./Damage.vue?vue&type=script&lang=js"

import "./Damage.vue?vue&type=style&index=0&id=b0bce9c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0bce9c2"]])

export default __exports__